import { Controller } from "@hotwired/stimulus"

// Same normalization as MutualInsurance#search_terms: no accents, no punctuation.
export function normalize (value) {
  return value
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim()
}

// Filters the mutual insurance directory by name as the visitor types, hiding
// empty letter groups and disabling their index links. Without JS the full list shows.
export default class extends Controller {
  static targets = ["input", "directory", "item", "group", "letter", "count", "empty"]
  static values = { countOne: String, countOther: String }

  filter () {
    const query = normalize(this.inputTarget.value)

    this.itemTargets.forEach((item) => {
      item.hidden = query !== "" && !item.dataset.search.includes(query)
    })

    const visibleLetters = new Set()
    this.groupTargets.forEach((group) => {
      group.hidden = this.itemTargets.every((item) => item.hidden || !group.contains(item))
      if (!group.hidden) visibleLetters.add(group.dataset.letter)
    })

    this.letterTargets.forEach((letter) => {
      const disabled = !visibleLetters.has(letter.dataset.letter)
      letter.classList.toggle("is-disabled", disabled)
      letter.toggleAttribute("aria-disabled", disabled)
      letter.tabIndex = disabled ? -1 : 0
    })

    const count = this.itemTargets.filter((item) => !item.hidden).length
    this.countTarget.textContent = (count > 1 ? this.countOtherValue : this.countOneValue).replace("{count}", count)
    this.emptyTarget.hidden = count > 0
  }

  // Enter in the header field jumps to the (already filtered) directory.
  submit (event) {
    event.preventDefault()
    this.filter()
    this.directoryTarget.scrollIntoView({ behavior: "smooth" })
  }

  // A "même prise en charge que" link may point to an insurer the filter hides.
  reveal (event) {
    const target = document.getElementById(event.currentTarget.hash.slice(1))
    if (!target?.hidden) return

    this.inputTarget.value = ""
    this.filter()
  }
}
